import { lazy } from 'react';
import { RoleBasedGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const ScreenSharePage = lazy(() => import('src/pages/screenshare/share'));

// ----------------------------------------------------------------------

const guardedScreenSharePage = (
  <RoleBasedGuard navigateTo roles={['school.teacher']}>
    <ScreenSharePage />
  </RoleBasedGuard>
);

export const screenShareRoutes = [
  {
    path: 'screenshare',
    children: [{ path: 'share', element: guardedScreenSharePage }],
  },
];
